import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { get, isEmpty } from 'lodash';
import moment from 'moment-timezone';
import { Chip, Grid, TextField, Typography } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import Document from 'components/Document';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import expertiseExpertiseIcon from 'images/expert-expertise-icon.svg';
import messages from 'containers/ExpertExpertise/messages';
import { COLORS } from 'constants/design';
import { Container } from 'containers/ExpertExpertise/FillExpertise/style';
import ActionButton from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ActionButton';
import { translate } from 'containers/services/translate';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import {
  MISSION_EXPERISE_VICTIM_STATUS,
  MISSION_POSTPONE_STATUS,
} from 'containers/data-structure';
import { renderTitleAccordion } from 'containers/ExpertExpertise/Recap/utils';
import { StyledActionButton } from 'components/Buttons/styled-component';
import PostPoneExpertise from 'containers/ExpertExpertise/Dialogs/PostPoneExpertiseDialog';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { handleOpenDocument } from 'services/utils';
import LabelValue from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/LabelValue';
export interface RecapPostPoneExpertiseProps {
  intl: IntlShape;
  title: string;
  missionPostPoneExpertise: any;
  isManager: boolean;
  openValidationModal?: Function;
  setSelectedPostPone?: Function;
  openRejectionModal?: Function;
  requestUpdateMissionPostPone: Function;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  sagis_code: any;
  requestGetDocByDocumentumId: Function;
}

const RecapPostPoneExpertise: FC<RecapPostPoneExpertiseProps> = (
  props,
): JSX.Element => {
  const { title } = props;
  const [openPostPoneDialog, setOpenPostPoneDialog] = useState(false);
  const [postPoneToEdit, setPostPoneToEdit] = useState({});
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );
  return (
    <Container>
      {!isEmpty(props.missionPostPoneExpertise) &&
        props.missionPostPoneExpertise.map((element: any) => (
          <CustomAccordion
            title={
              (
                <Grid container direction="row" justify="space-between">
                  <Grid item>
                    {renderTitleAccordion(
                      get(element, 'missionPostPone'),
                      title,
                    )}
                  </Grid>

                  <Grid item>
                    {!props.isManager &&
                      get(element.missionPostPone, 'status') ===
                        MISSION_POSTPONE_STATUS.REJECTED &&
                      props.sagis_code ===
                        get(element.missionPostPone, 'createdBy') && (
                        <StyledActionButton
                          title={translate(messages.updateTitle, props)}
                          lefticon={
                            <EditIcon
                              style={{
                                height: '14px',
                                width: '14px',
                                marginRight: '8px',
                              }}
                            />
                          }
                          onClick={
                            /* istanbul ignore next */ () => {
                              setOpenPostPoneDialog(true);
                              setPostPoneToEdit(element);
                            }
                          }
                        />
                      )}
                  </Grid>
                </Grid>
              ) as any
            }
            textColor={COLORS.ACCORDION_TEXT_BLUE}
            bgColor={COLORS.ACCORDION_BG_BLUE}
            image={expertiseExpertiseIcon}
          >
            <Grid container spacing={2} alignItems={'center'}>
              {!props.sagis_code && (
                <Grid item xs={12}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={4}>
                      <LabelValue
                        title={
                          translate(messages.referenceMisionTitle, props) + ':'
                        }
                        value={get(
                          element,
                          'missionPostPone.mission.reference',
                        )}
                      />
                    </Grid>

                    {get(
                      element,
                      'missionPostPone.mission.courtFileNumber',
                    ) && (
                      <Grid item xs={4}>
                        <LabelValue
                          title={
                            translate(messages.courtFileNumberTitle, props) +
                            ':'
                          }
                          value={get(
                            element,
                            'missionPostPone.mission.courtFileNumber',
                          )}
                        />
                      </Grid>
                    )}

                    <Grid item xs={4}>
                      <LabelValue
                        title={
                          translate(messages.procedureTypeTitle, props) + ':'
                        }
                        value={
                          getValueByCode(
                            get(
                              element,
                              'missionPostPone.mission.procedureNatureId',
                            ),
                            get(listings, 'procedureNature', []),
                          ) as any
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={2}>
                <TextField
                  label={translate(messages.reason, props)}
                  value={element?.missionPostPone?.reason}
                  className="input"
                  fullWidth
                />
              </Grid>
              {props.isManager &&
                get(element, 'missionPostPone.mission.missionDate') && (
                  <Grid item>
                    <TextField
                      label={translate(messages.missionDate, props)}
                      value={moment(
                        element?.missionPostPone?.mission?.missionDate,
                      ).format('DD/MM/YYYY')}
                      className="input"
                      fullWidth
                    />
                  </Grid>
                )}
              {get(element, 'missionPostPone.postponeDate') && (
                <Grid item>
                  <TextField
                    label={translate(messages.postponeDateField, props)}
                    value={moment(element.missionPostPone.postponeDate).format(
                      'DD/MM/YYYY',
                    )}
                    className="input"
                    fullWidth
                  />
                </Grid>
              )}
              {props.isManager &&
                (!element?.missionPostPone?.status ||
                  element?.missionPostPone?.status ===
                    MISSION_EXPERISE_VICTIM_STATUS.PENDING) && (
                  <Grid item xs={6}>
                    <ActionButton
                      handleOpenDialogValidation={
                        /* istanbul ignore next */ () => {
                          props.openValidationModal &&
                            props.openValidationModal();
                          props.setSelectedPostPone &&
                            props.setSelectedPostPone(element);
                        }
                      }
                      handleOpenDialogRejection={
                        /* istanbul ignore next */ () => {
                          props.openRejectionModal &&
                            props.openRejectionModal();
                          props.setSelectedPostPone &&
                            props.setSelectedPostPone(element);
                        }
                      }
                      shouldDisplayAppreciation={false}
                    />
                  </Grid>
                )}
              {get(element, 'missionPostPone.document') && (
                <Grid item xs={props.isManager && 12}>
                  <section>
                    <div style={{ marginTop: '10px' }}>
                      <Document
                        name={get(element, 'missionPostPone.document.name', '')}
                        type={get(element, 'missionPostPone.document.type', '')}
                        icon={
                          <VisibilityIcon
                            className="consult"
                            onClick={handleOpenDocument(
                              get(
                                element,
                                'missionPostPone.document',
                                {},
                              ) as any,
                              props.requestGetDocByDocumentumId,
                            )}
                          />
                        }
                      />
                    </div>
                  </section>
                </Grid>
              )}
              {get(element?.missionPostPone, 'status') !==
                MISSION_POSTPONE_STATUS.PENDING &&
                get(element?.missionPostPone, 'decidedBy') && (
                  <Grid item xs={12}>
                    <Grid item>
                      <Typography
                        style={{
                          color: COLORS.LIGHT_GREY,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {translate(messages.decidedBy, props)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        style={{
                          color: COLORS.TEXT_BLACK,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {get(element?.missionPostPone, 'decidedBy')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: COLORS.LIGHT_GREY,
                    fontWeight: 400,
                    fontSize: '13px',
                  }}
                >
                  {translate(messages.statusMissionPostPoneTitle, props)}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Chip
                  style={{
                    backgroundColor: renderColor(
                      element?.missionPostPone?.status,
                    ),
                    color: COLORS.WHITE,
                    fontWeight: 700,
                  }}
                  label={renderChipLabel(element?.missionPostPone?.status)}
                />
              </Grid>
              {get(element?.missionPostPone, 'status') ===
                MISSION_POSTPONE_STATUS.REJECTED &&
                get(element?.missionPostPone, 'rejectReason') && (
                  <>
                    <Grid item>
                      <Typography
                        style={{
                          color: COLORS.LIGHT_GREY,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {translate(messages.reason, props) + ':'}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        style={{
                          color: COLORS.TEXT_BLACK,
                          fontWeight: 400,
                          fontSize: '13px',
                        }}
                      >
                        {get(element?.missionPostPone, 'rejectReason')}
                      </Typography>
                    </Grid>
                  </>
                )}

              {get(element?.missionPostPone, 'comment') && (
                <>
                  <Grid item>
                    <Typography
                      style={{
                        color: COLORS.LIGHT_GREY,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {translate(messages.comment, props) + ':'}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      style={{
                        color: COLORS.TEXT_BLACK,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {get(element?.missionPostPone, 'comment')}
                    </Typography>
                  </Grid>
                </>
              )}
              {get(element?.missionPostPone, 'createdBy') && (
                <Grid item xs={12}>
                  <Grid item>
                    <Typography
                      style={{
                        color: COLORS.LIGHT_GREY,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {translate(messages.createdByTitle, props)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      style={{
                        color: COLORS.TEXT_BLACK,
                        fontWeight: 400,
                        fontSize: '13px',
                      }}
                    >
                      {getValueByCodeSagis(
                        get(element?.missionPostPone, 'createdBy') as string,
                        get(listings, 'intervenants'),
                      )}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <PostPoneExpertise
              open={openPostPoneDialog}
              onClose={
                /* istanbul ignore next */ () => setOpenPostPoneDialog(false)
              }
              validateDialog={props.requestUpdateMissionPostPone}
              uploadDocument={props.uploadDocument}
              uploadedDocument={props.uploadedDocument}
              missionId={get(postPoneToEdit, 'missionPostPone.missionId')}
              resetUploadedDocument={props.resetUploadedDocument}
              recap={postPoneToEdit}
              missionDate={get(
                postPoneToEdit,
                'missionPostPone..mission?.missionDate',
              )}
            />
          </CustomAccordion>
        ))}
    </Container>
  );
};

export default injectIntl(RecapPostPoneExpertise);
